module.exports = __webpack_public_path__ + "img/隨緣自強 的副本.c53abb53.jpg";